import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { createRootModal } from '../../RootModal';
import './PinCode.scss';

const PinCode = createRootModal(function PinCode() {
	const { confirm } = useSelector(state => state.app.modal.outsideParams);
	const [pinArr, setPinArr] = useState(new Array(6).fill(''));
	const [needChangeFocus, setNeedChangeFocus] = useState(false);

	const pinRef = useRef([]);

	const pinChange = async (value, index) => {
		if (/^[0-9]?$/.test(value)) {
			const newPinArr = [...pinArr];
			newPinArr[index] = value;

			setPinArr(newPinArr);

			if (!value) return;

			index < 5 && pinRef.current[index + 1].focus();

			if (index === 5) {
				await confirm(newPinArr.join(''));

				pinRef.current = [];
				setPinArr(new Array(6).fill(''));
				setNeedChangeFocus(true);
			}
		}
	};

	const pinKeyDown = (e, index) => {
		if (e.key === 'Backspace' && !pinArr[index] && index > 0) pinRef.current[index - 1].focus();
	};

	const handleClick = () => pinRef.current.find(i => i.value === '').focus();

	useEffect(() => {
		const timer = setTimeout(() => {
			pinRef.current[0].focus();
		}, 600);

		return () => clearTimeout(timer);
	}, []);

	useEffect(() => {
		if (needChangeFocus) {
			pinRef.current.find(i => i.value === '').focus();
			setNeedChangeFocus(false);
		}
	}, [needChangeFocus]);

	return (
		<div className='Modal-PinCode'>
			<div className='PinCode-like-module'>
				{pinArr.map((item, index) => (
					<div
						key={index}
						className={classNames('input-wrapper', {
							'not-empty': pinRef.current[index]?.value,
							'visible-caret': index === pinRef.current.filter(i => i.value).length,
						})}
					>
						<input
							type='text'
							inputMode='numeric'
							pattern='[0-9]*'
							maxLength={1}
							value={item}
							ref={el => (pinRef.current[index] = el)}
							onClick={handleClick}
							onChange={e => pinChange(e.target.value, index)}
							onKeyDown={e => pinKeyDown(e, index)}
						/>
					</div>
				))}
			</div>
		</div>
	);
});

export default PinCode;
